import server from '../api/server.vue'
import {bus} from '../core/utils/bus.js'
import { Auth } from '../core/utils/auth'
import store from '../store'
import AioNavBar from './AioNavBar.vue'
import ThalesNavBar from './ThalesNavBar.vue'

export default {
  name: 'App',
  data () {
    return {
      waitingNextInput: false,
      inputArray: [],
      clientRegistered: false,
      form: {
        client: ''
      },
      show: true,
      currentStep: null
    }
  },
  methods: {
    getUsername () {
      return store.getters.getPayload.name
    },
    onReset (evt) {
      evt.preventDefault()
      /* Reset our form values */
      this.form.client = ''
      /* Trick to reset/clear native browser form validation state */
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
    setFuncTimeout () {
      if (!this.waitingNextInput) {
        this.inputArray = []
      }
      this.time = setTimeout(function () {
        this.setFuncTimeout()
      }.bind(this), 5000)
    },
    reloadPage () {
      this.setProtectedTimeout(function () { window.location.reload() }, 3600 * 24 * 1000)
    },
    setPrinterLocalstorage () {
      localStorage.setItem('printer_type', 'zebra')
    },
  },
  mounted: function () {
    this.clientRegistered = true
    if (!this.isUserThales()) {
      // document.addEventListener('keydown', this.inputListener)
    }
    else if (this.isUserThales()) {
      this.setPrinterLocalstorage()
      if (this.readOnlyThales() && !this.$route.fullPath.includes('tracking_order')) {
        this.goTo('/tracking_order')
      } else if (!this.readOnlyThales() && this.$route.fullPath === '/') {
        this.goTo('/flux')
      }
    }
    this.reloadPage()
  },
  components: {AioNavBar, ThalesNavBar}
}



// WEBPACK FOOTER //
// ./src/app/app.js